/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Tlm_3Inputs */

const en_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`delivery`)
};

const ar_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسليم`)
};

const bn_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`delivery`)
};

const de_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferung`)
};

const es_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entrega`)
};

const fr_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison`)
};

const pt_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entrega`)
};

const zh_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交付`)
};

const tr_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teslimat`)
};

const ru_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`доставка`)
};

const pl_svc_web_scraping_tlm_3 = /** @type {(inputs: Svc_Web_Scraping_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostarczanie`)
};

/**
* | output |
* | --- |
* | "delivery" |
*
* @param {Svc_Web_Scraping_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_tlm_3 = /** @type {((inputs?: Svc_Web_Scraping_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_tlm_3(inputs)
	if (locale === "bn") return bn_svc_web_scraping_tlm_3(inputs)
	if (locale === "de") return de_svc_web_scraping_tlm_3(inputs)
	if (locale === "es") return es_svc_web_scraping_tlm_3(inputs)
	if (locale === "fr") return fr_svc_web_scraping_tlm_3(inputs)
	if (locale === "pt") return pt_svc_web_scraping_tlm_3(inputs)
	if (locale === "zh") return zh_svc_web_scraping_tlm_3(inputs)
	if (locale === "tr") return tr_svc_web_scraping_tlm_3(inputs)
	if (locale === "ru") return ru_svc_web_scraping_tlm_3(inputs)
	if (locale === "pl") return pl_svc_web_scraping_tlm_3(inputs)
	return en_svc_web_scraping_tlm_3(inputs)
});
export { svc_web_scraping_tlm_3 as "svc_web-scraping_tlm_3" }